const EmptyState = ({ message = "موردی برای نمایش وجود ندارد." }) => (
  <p className="w-full py-16 text-center text-sm text-gray-400">{message}</p>
);

export default EmptyState;
